import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useUserBadgeCount() {
  const { server } = useServer()
  return useQuery<number>({
    queryKey: keys.badge(),
    queryFn: fetchAppBadgeCount,
  })

  async function fetchAppBadgeCount() {
    const response = await server.get<number>('/v2/users/me/badge')
    return response
  }
}
